<template>
	<div id="videoes">
		<div class="rightContent">
			<div class="tableheader">
				<div style="text-align:right;float:right">
					<el-button @click="implodeGoods()" class="btn1" type="primary" size="mini">Exls导入视频信息</el-button>
					<el-button @click="editGoods(false)" class="btn1" type="primary" size="mini">添加视频信息</el-button>
				</div>
			</div>
			<div class="listBlock">
				<el-table :data="lists" style="width: 100%">
					<el-table-column width="70" prop="id" label="ID"></el-table-column>
					<el-table-column prop="name" label="视频标题"></el-table-column>
					<el-table-column prop="filename" label="视频文件"></el-table-column>
					<el-table-column prop="crt_time" width="170" label="上传时间"></el-table-column>
					<el-table-column width="180" label="操作">
						<template slot-scope="scope">
							<el-button @click="editGoods(scope.row)" class="btn1" type="primary" size="mini">编辑</el-button>
							<el-button @click="deleteGoods(scope.row.id)" class="btn1" type="primary" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="margin-top:10px;text-align:center;">
					<el-pagination background layout="prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					 :page-size="pageSize" :current-page="pageNo" :page-sizes="[10,20,50,100]" :total="datatotal">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog width="40%" :title="imageControllerName" :visible.sync="dialogFormVisible">
			<el-form :model="saveForm">
				<el-form-item label="视频标题" :label-width="formLabelWidth">
					<el-input v-model="saveForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="视频文件" :label-width="formLabelWidth">
					<el-input v-model="saveForm.filename" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitSave()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog width="30%" title="Exls导入视频信息" :visible.sync="dialogImplode">
			<el-form v-model="implodeForm">
				<el-upload class="avatar-uploader" name="name" action="/kaiSrv/vedio/put" :show-file-list="false" :on-success="uploadFileOk" :before-upload="beforeUpload">
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2M</div>
					<div slot="tip" class="el-upload__tip"><a style="color: #0066CC;" href="/kaiSrv/vedio/get//kaiSrv/vedio/get/20210330/d6d12beca3dc825ee9af36b83b77b2e0-16170825349484.xlsx">下载模板Exls文件</a></div>
				</el-upload>
			</el-form>
			<div v-if="implodeForm.filename">
			  <input style="width: 90%;" :value="'/kaiSrv/vedio/get/'+implodeForm.filename" type="text" disabled="disabled" />
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogImplode = false">取 消</el-button>
				<el-button type="primary" @click="submitImplode()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: "videoes",
		data() {
			return {
				doing: false,
				lists: [],
				imageControllerName: '新增视频',
				dialogFormVisible: false,
				dialogImplode: false,
				formLabelWidth: '120px',
				datatotal: 0,
				pageNo: 1,
				pageSize: 20,
				uploading: null,
				fileList: [],
				saveForm: {
					name: '',
					filename: '',
					id: ''
				},
				implodeForm: {
					filename: ''
				}
			};
		},
		computed: {},
		created() {
			this.resizedwindow();
			this.getList();
		},
		methods: {
			beforeUpload(file) {
			  const xls = file.type === "application/vnd.ms-excel";
			  const xlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
			  const isLt2M = file.size / 1024 / 1024 < 2;
			
			  if (!xls && !xlsx) {
			    this.$message.error('上传文件必须是xls或者xlsx表格');
			  }
			  if (!isLt2M) {
			    this.$message.error('文件大小不能超过2M');
			  }
			  this.uploading = this.openFullScreen()
			  return (xls || xlsx) && isLt2M;
			},
			uploadFileOk(res, file) {
			  this.implodeForm.filename = URL.createObjectURL(file.raw);
			  if (res.code == 10000) {
			    this.implodeForm.filename = res.img_path;
			  }
			  this.uploading.close()
			},
			submitImplode(){
				if (this.doing === true) {
					return false;
				}
				let dataLoadIng = this.openFullScreen();
				this.doing = true;
				let _this = this;
				let data = this.implodeForm;
				this.axios
					.post("/kaiSrv/mgr/vedioImplode", this.formData(data))
					.then(function(response) {
						_this.doing = false;
						_this.dialogImplode = false;
						_this.getList();
						setTimeout(() => {
							dataLoadIng.close();
						}, 500);
					});
			},
			implodeGoods(){
				this.dialogImplode = true
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNo = val
				this.getList()
			},
			getList() {
				if (this.doing === true) {
					return false;
				}
				let dataLoadIng = this.openFullScreen()
				this.doing = true;
				let _this = this;
				this.axios.post("/kaiSrv/mgr/vedioList", {pageNo: this.pageNo, pageSize: this.pageSize})
					.then(function(response) {
						_this.doing = false;
						if (response.data.code == 0) {
							_this.lists = response.data.list;
							_this.datatotal = parseInt(response.data.total)
						}
						_this.implodeForm.filename = ''
						_this.saveForm = {
							name: '',
							filename: '',
							id: ''
						}
						setTimeout(() => {
							dataLoadIng.close()
						}, 500);
					});
			},
			editGoods(data) {
				this.saveForm.filename = '';
				this.saveForm.name = '';
				this.saveForm.id = '';
				if (data) {
					this.saveForm.filename = data.filename;
					this.saveForm.name = data.name;
					this.saveForm.id = data.id;
				}
				this.dialogFormVisible = true;
			},
			deleteGoods(id) {
				if (this.doing === true) {
					return false
				}
				let dataLoadIng = this.openFullScreen()
				this.doing = true
				let _this = this
				this.axios
					.post("/kaiSrv/mgr/vedioDelete", {
						id: id
					})
					.then(function(response) {
						_this.doing = false
						_this.getList();
						setTimeout(() => {
							dataLoadIng.close();
						}, 500);
					});
			},
			submitSave() {
				if (this.doing === true) {
					return false;
				}
				let dataLoadIng = this.openFullScreen();
				this.doing = true;
				let _this = this;
				let data = this.saveForm;
				this.axios
					.post("/kaiSrv/mgr/vedioSave", this.formData(data))
					.then(function(response) {
						_this.doing = false;
						_this.dialogFormVisible = false;
						_this.getList();
						setTimeout(() => {
							dataLoadIng.close();
						}, 500);
					});
			}
		}
	};
</script>
<style lang="scss">
	#videoes {
		.tabs-container {
			.el-card__header {
				padding: 0.0833rem 0.1667rem !important;
			}

			.el-card {
				cursor: pointer;
			}

			.el-card:hover {
				border: $blue 1px solid;
			}
		}

		.el-input__inner {
			width: 2.5rem;
		}

		.codeshearch,
		.codeshearch .el-input__inner {
			width: 1.5rem;
		}

		.el-pagination .el-input__inner {
			width: 0.9rem;
		}

		.codeshearch {
			margin-left: 0.05rem;
			margin-right: 0.02rem;
		}

		.avatar-uploader,
		.el-upload,
		.el-upload--text {
			display: inline-block;
		}

		.avatar-uploader-icon {
			border: 1px solid #ccc;
		}
	}
</style>
<style scoped lang="scss">
	#videoes {
		box-sizing: border-box;

		.rightContent {
			width: calc(100% - 0.32rem);
			height: calc(100% - 0.1667rem);
			display: inline-block;
			background-color: #fff;
			margin-left: 0.1667rem;
			margin-top: 0.1667rem;
			border-radius: 0.05rem;

			.tableheader {
				margin: 0.16rem;
			}

			p.title {
				height: 0.4167rem;
				line-height: 0.4167rem;
				font-size: 0.15rem;
				color: #000;
			}

			.btn2,
			.btn3 {
				padding: 0.0667rem 0.0833rem;
				background-color: #409EFF;
				border: 1px solid #409EFF;
			}

			.listBlock {
				margin: 0.08rem;
			}

			.warncolor {
				color: red;
			}

			.btndel {
				margin-left: 0.1rem;
				height: 0.28rem;
				position: relative;
				top: 0.05rem;
			}
		}

		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
			width: 1.22rem;
			height: 0.5rem;
			margin-left: 1rem;
		}

		.avatar-uploader .el-upload:hover {
			border-color: #409eff;
		}

		.avatar-uploader-icon {
			color: #8c939d;
			width: 1.22rem;
			height: 1.22rem;
			text-align: center;
			line-height: 1.22rem;
			margin-top: 0.08rem;
		}

		.imgblockForLogo {
			width: 1.22rem;
			height: 1.22rem;
			display: inline-block;
			border: 1px solid #ccc;
			margin-top: 0.08rem;
		}

		.avatar {
			width: 1.22rem;
			height: 1.22rem;
			display: block;
		}
	}

	.uploader-example {
		width: 400px;
		padding: 15px;
		margin: 0;
		font-size: 12px;
		box-shadow: 0 0 10px rgba(0, 0, 0, .4);
	}

	.uploader-example .uploader-btn {
		margin-right: 4px;
	}

	.uploader-example .uploader-list {
		max-height: 440px;
		overflow: auto;
		overflow-x: hidden;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/video.vue